import {
  exportDebugSheets,
  getGapi,
  mergeSheetsRows,
} from "fe-web-components/diagnostics/debugsheetExporter";
import * as React from "react";
import { DebugSheetFragment } from "fe-common/graphql";
import { Button, styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { memo, useCallback, useEffect } from "react";
import { useSuggestionsForPlan } from "./hooks/useSuggestionsForPlan";

const GoogleButton = styled(Button)(({ theme }) => ({
  background: KahunColorMap.Background,
  position: "absolute",
  bottom: theme.spacing(2),
  right: theme.spacing(4),
}));

const getGoogleSignedIn = () => {
  // @ts-ignore
  return (
    getGapi() &&
    getGapi()
      .auth2?.getAuthInstance()
      ?.isSignedIn?.get()
  );
};

export const DebugSheet = memo(
  ({ debugSheets }: { debugSheets: DebugSheetFragment[] }) => {
    const { suggestionDebug: suggestionDebugSheet } = useSuggestionsForPlan();

    const [isGoogleLoggedIn, setIsGoogleLoggedIn] = React.useState(false);

    useEffect(() => {
      // @ts-ignore
      setTimeout(
        () =>
          getGapi() &&
          getGapi().load("auth2", () =>
            setIsGoogleLoggedIn(getGoogleSignedIn()),
          ),
        600,
      );
    }, []);

    if (debugSheets && suggestionDebugSheet?.rows?.length) {
      const nextStepSheet = { name: "NextStep", sheet: suggestionDebugSheet };
      const currentNextStepSheet = debugSheets.findIndex(
        (s) => s.name === "NextStep",
      );
      if (currentNextStepSheet) {
        debugSheets[currentNextStepSheet] = nextStepSheet;
      } else {
        debugSheets.push(nextStepSheet);
      }
    }

    const onClick = useCallback(() => {
      if (isGoogleLoggedIn) {
        return exportDebugSheets(debugSheets, null).catch((e) =>
          console.log(e),
        );
      } else {
        return getGapi()
          .auth2.getAuthInstance()
          .signIn()
          .then(() => setIsGoogleLoggedIn(getGoogleSignedIn()))
          .catch((e) => {
            console.log(e);
            setIsGoogleLoggedIn(getGoogleSignedIn());
          });
      }
    }, [isGoogleLoggedIn, debugSheets]);

    return (
      <GoogleButton onClick={onClick}>
        {isGoogleLoggedIn
          ? "Open Debug Sheet"
          : " Debug Sheet - Login to Google"}
      </GoogleButton>
    );
  },
);
